export default __webpack_public_path__ + "static/media/Wheat Seeds.2ff40bc0.PNG";